import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";

interface IIcon {
  color: string;
}

const CheckIcon: React.FC<IIcon> = ({ color }) => {
  return <FontAwesomeIcon icon={faCheckCircle} style={{ color }} />;
};

export default CheckIcon;
